export enum PartnerStatus {
    UNDER_REVIEW = "UNDER_REVIEW",
    APPROVED = "APPROVED",
    REJECTED = "REJECTED",
    REQUIRE_ADDITIONAL_INFO = "REQUIRE_ADDITIONAL_INFO"
}